const styles = [
  // {
  //   featureType: 'water',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#e9e9e9',
  //     },
  //     {
  //       lightness: 17,
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#f5f5f5',
  //     },
  //     {
  //       lightness: 20,
  //     },
  //   ],
  // },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  // {
  //   featureType: 'poi',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#f5f5f5',
  //     },
  //     {
  //       lightness: 21,
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi.park',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#dedede',
  //     },
  //     {
  //       lightness: 21,
  //     },
  //   ],
  // },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  // {
  //   featureType: 'transit',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#f2f2f2',
  //     },
  //     {
  //       lightness: 19,
  //     },
  //   ],
  // },
  // {
  //   featureType: 'administrative',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#fefefe',
  //     },
  //     {
  //       lightness: 20,
  //     },
  //   ],
  // },
  // {
  //   featureType: 'administrative',
  //   elementType: 'geometry.stroke',
  //   stylers: [
  //     {
  //       color: '#fefefe',
  //     },
  //     {
  //       lightness: 17,
  //     },
  //     {
  //       weight: 1.2,
  //     },
  //   ],
  // },
];

/* eslint-disable no-undef */
window.initMap = function () {
  // activate main map
  if (typeof mapPosition !== 'undefined' && mapPosition) {
    const mapEl = document.querySelector('#map');

    // Zoom out more on mobile
    const mqMobile = window.matchMedia('(max-width: 699px)');
    const zoom = mqMobile.matches ? 14 : 15;

    const map = new google.maps.Map(mapEl, {
      center: mapPosition,
      zoom,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    map.setOptions({ styles });

    const mainMarkerIcon = {
      url: '/images/map-pin-brown.svg',
      size: null /* size is determined at runtime */,
      origin: null /* origin is 0,0 */,
      anchor: new google.maps.Point(
        9,
        22
      ) /* anchor is bottom center of the scaled image */,
      scaledSize: new google.maps.Size(
        18,
        23
      ) /* Size given in CSS Length units */,
    };

    // eslint-disable-next-line no-unused-vars
    const mainMarker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: mainMarkerIcon,
    });

    const logoIcon = {
      url: '/images/lambert-logo-black.svg',
      size: null /* size is determined at runtime */,
      origin: null /* origin is 0,0 */,
      anchor: new google.maps.Point(93, -16),
      scaledSize: new google.maps.Size(
        186,
        56
      ) /* Size given in CSS Length units */,
    };

    // eslint-disable-next-line no-unused-vars
    const logoMarker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: logoIcon,
    });

    // Extra map markers
    const extraMarkerEls = document.querySelectorAll('.js-map-marker');
    const extraMarkers = [];

    extraMarkerEls.forEach((marker) => {
      const markerPosition = {
        lat: parseFloat(marker.dataset.lat),
        lng: parseFloat(marker.dataset.lng),
      };
      const markerText = marker.dataset.text;

      const markerIcon = {
        url: '/images/map-pin-brown.svg',
        size: null /* size is determined at runtime */,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(
          9,
          22
        ) /* anchor is bottom center of the scaled image */,
        scaledSize: new google.maps.Size(
          18,
          23
        ) /* Size given in CSS Length units */,
        labelOrigin: new google.maps.Point(9, 35),
      };

      // eslint-disable-next-line no-unused-vars
      extraMarkers.push({
        position: markerPosition,
        label: {
          text: markerText,
          className: 'map__marker-label',
          fontFamily: "'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontWeight: '400',
        },
        map,
        icon: markerIcon,
      });
    });

    extraMarkers.forEach((marker) => {
      // eslint-disable-next-line no-new
      new google.maps.Marker(marker);
    });
  }
};
/* eslint-enable no-undef */
